<template>
  <v-app  :style="{ background: $vuetify.theme.themes[theme].background }">
    <Navigation v-if="showNav"/>
    <v-main>
      <div v-if="!showLoading">
        <v-row>
          <v-col
            class="d-flex justify-center align-center text-center"
            style="height: 100vh;"
          >
            <v-alert type="error">
              Your email is not from a valid Vox Media domain. 
              Please go to lms.voxmedia.com/logout 
              and then log back in with a valid Vox Media email address.
            </v-alert>
          </v-col>
        </v-row>
      </div>
      <div v-if="loadingApp">
        <v-row>
          <v-col
            class="d-flex justify-center align-center text-center"
            style="height: 100vh;"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              :size="100"
              :width="10"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <router-view></router-view>
      </div>
    </v-main>
    <Snackbar/>
  </v-app>
</template>

<script>
import firebase from 'firebase'
import Navigation from '@/components/Navigation'
import Snackbar from '@/components/Snackbar'

export default {
  name: 'App',
  components: {
    Navigation,
    Snackbar
  },
  computed: {
    loadingApp () {
      return this.$store.getters.getLoadingApp
    },
    showNav () {
      return this.$store.getters.getShowNav
    },
    theme () {
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  },
  data: () => ({
    showLoading: true
  }),
  async created () {
    firebase.auth().onAuthStateChanged(async user => {
      if (!user) {
        return this.$store.dispatch('setUser', null)
      }
      const email = user.email
      const validDomains = [
        'nowthismedia.com', 
        'popsugar.com', 
        'groupninemedia.com',
        'seeker.com',
        'groupninefreelancers.com',
        'thrillist.com',
        'thedodo.com',
        'voxmedia.com',
        'theverge.com',
        'sbnation.com',
        'polygon.com',
        'eater.com',
        'vox.com',
        'racked.com',
        'curbed.com',
      ]
      const domain = email.split('@')[1]
      const emailInValidDomain = validDomains.includes(domain)
      console.log(emailInValidDomain)
      if (!emailInValidDomain) this.showLoading = false
      this.init(user, { retry: true })
    })
  },
  methods: {
    async init (user, options) {
      try {
        const userRecords = await this.$store.dispatch('getRecords', {
          table: 'Users',
          view: 'All Users',
        })
        const customMeta = userRecords.find(record => {
          return user.uid === record.fields['Firebase ID']
        })
        if (!customMeta && options.retry) {
          return this.init(user, { retry: false })
        }
        user.customMeta = customMeta
        this.$store.dispatch('setUser', user)
      } catch (err) {
        if (options.retry) {
          // if we get an error, try again. firebase is very fast and a signup 
          // may create a race condition where their airtable user record is
          // still being written after firebase sign up
          setTimeout(() => {
            this.init(user, { retry: false })
          }, 2000)
        }
      }
    }
  }
};
</script>

<style>
/* @font-face {
  font-family: Circular;
  src: url('./assets/fonts/circular/lineto-circular-book.ttf') format("truetype");
} */
body {
  font-family: 'Montserrat', sans-serif;
}
.slide-fade-down-slow-enter-active {
  transition: all .8s ease;
}
.slide-fade-down-slow-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-down-slow-enter, .slide-fade-down-slow-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(100px);
  opacity: 0;
}
.slide-fade-up-slow-enter-active {
  transition: all .8s ease;
}
.slide-fade-up-slow-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-up-slow-enter, .slide-fade-down-slow-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-100px);
  opacity: 0;
}
.slide-fade-down-and-back-enter-active {
  transition: all .3s ease;
}
.slide-fade-down-and-back-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-down-and-back-enter {
  transform: translateY(100px);
  opacity: 0;
}
.slide-fade-down-slow-leave-to {
  transform: translateY(-100px);
  opacity: 0;
}
.v-application {
  font-family: 'Montserrat', sans-serif;
}
.v-application .headline {
  font-family: inherit !important;
}
.v-expansion-panels {
  border-radius: 24px !important;
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile) > .v-expansion-panel--active {
  border-radius: 24px !important;
}
.v-sheet--shaped {
  border-radius: 24px !important;
}
.v-dialog--active {
  border-radius: 24px !important;
}
.v-sheet.v-list {
  border-radius: 24px !important;
}
.v-btn {
  text-transform: capitalize;
}
.v-tab {
  text-transform: capitalize !important;
}
.theme--light.v-tabs-items {
  background-color: transparent !important;
}
.theme--light.v-tabs > .v-tabs-bar {
  background-color: transparent !important;
}
.cursor-pointer {
  cursor: pointer !important;
}
.shaped {
  border-radius: 24px !important;
}
</style>
